module.exports = __webpack_public_path__ + "static/img/12.7a20551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/12.png
// module id = FUCY
// module chunks = 0